<template>
    <div>
        <div class="grid two" v-if=" matchesATP.length > 0 || matchesWTA.length > 0 ">
            <div class="SC-results__column" >

                <h3>
                    Men
                </h3>

                <score-live
                    v-if="matchesATP.length > 0"
                    type="atp"
                    :detail="detail"
                    :flag="this.flag"
                    :ticket="this.ticket">
                </score-live>

                <div class="na" v-else>
                    <h5 class="na__title" style="margin-bottom: 0">
                        Currently there are no live ATP matches
                    </h5>
                </div>

            </div>


            <div class="SC-results__column" >

                <h3>
                    Women
                </h3>

                <score-live
                    v-if="matchesWTA.length > 0"
                    type="wta"
                    :detail="detail"
                    :flag="this.flag"
                    :ticket="this.ticket">
                </score-live>

                <div class="na" v-else>
                    <h5 class="na__title" style="margin-bottom: 0">
                        Currently there are no live WTA matches
                    </h5>
                </div>

            </div>

        </div>

        <div class="na" v-else>
            <h5 class="na__title" style="margin-bottom: 0">
                Currently there are no live ATP/WTA matches
            </h5>
        </div>


    </div>
</template>

<script>
    import axios from 'axios'
    import Live from './Live'

    export default {
        props: ['type', 'flag', 'detail', 'ticket'],
        components: {
            'score-live': Live,
        },
        data() {
            return {
                matchesATP: [],
                matchesWTA: [],
                feedATP: [],
                feedWTA: [],
            }
        },
        created: function () {

            this.getLiveATP()
            this.getLiveWTA()



            let app = this
            setInterval(function () {
                app.getLiveATP()
                app.getLiveWTA()
            }, 15 * 1000, app)

        },
        methods: {
            getLiveATP() {

                let url = `${window.feed_ip}/get/atp/${window.tournament}/live`

                axios.get( url ).then( response => {

                    this.feedATP = response.data

                    let liveMatches = response.data

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matchesATP = liveMatches

                }).catch( function ( error ) {
                    console.log( error )
                })

            },
            getLiveWTA() {

                let url = `${window.feed_ip}/get/wta/${window.tournament}/live`

                axios.get( url ).then( response => {

                    this.feedWTA = response.data

                    let liveMatches = response.data

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matchesWTA = liveMatches

                }).catch( function ( error ) {
                    console.log( error )
                })

            }

        }
    }
</script>
